export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "HDFC Home Loan EMI Calculator: Effortlessly Plan Your Home Loan Repayments",
    subHeading:
      "Use HDFC's Home Loan EMI Calculator to calculate your monthly home loan repayments. This easy-to-use tool helps you estimate your EMI amount, plan your finances accordingly, and ensures that you stay within your budget. By entering your loan details, you can get an accurate estimate and understand your financial commitments clearly.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
